import Menu from "../../components/Menu"
import RoundyContainer from "../../components/RoundyContainer"
import { VehicleChangeContextComp } from "../../components/ChangeRequest_VehicleChangeComp/VehicleChangeContext"
import VehicleConfirmationMain from "../../components/ChangeRequest_VehicleChangeComp/4_Confirmation/VehicleConfirmationMain"
import { useEffect } from "react"

const VehiclesConfirmation = (props) => {
    const { userData } = props.user

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <VehicleChangeContextComp>
                <Menu Title={"VEHICLE CHANGE"} FirstName={userData.firstName} userData={userData} />
                <RoundyContainer Content={VehicleConfirmationMain} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData
                    }}
                />
            </VehicleChangeContextComp>
        </>
    )
}

export default VehiclesConfirmation